const BUGSNAG_CONSTANTS = {
  SEVERITY: {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
  },
};

module.exports = BUGSNAG_CONSTANTS;
